import { render, staticRenderFns } from "./PleitoMetas.vue?vue&type=template&id=7476e540"
import script from "./PleitoMetas.vue?vue&type=script&lang=js"
export * from "./PleitoMetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports